import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';

import {Feedback, HumidifierDoorStatus, TaskType} from 'constants/dataEnum';
import {showSnackbar} from 'stores/actions/appStateAction';
import {getTasksByType} from 'stores/selectors/cardStateSelector';
import {
  selectHumidifierDoorStatus,
  selectIsHumidifierConnected,
  selectIsHumidifierInstalled,
} from 'stores/selectors/humidifierSelectors';
import {checkAndPumpWater} from 'stores/business/humidifierBusiness';

function useHumidityWarnings() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();

  const isHumidifierInstalled = useSelector(selectIsHumidifierInstalled);
  const isHumidifierConnected = useSelector(selectIsHumidifierConnected);
  const humidifierDoorStatus = useSelector(selectHumidifierDoorStatus);
  const humidityTask = useSelector(getTasksByType(TaskType.ENABLE_HUMIDIFIER));
  const isProtocolHumidityEnabled = Boolean(humidityTask);

  const checkHumidityWarnings = async () => {
    if (!isHumidifierInstalled || !isHumidifierConnected || !isProtocolHumidityEnabled) return true;

    if (humidifierDoorStatus === HumidifierDoorStatus.OPEN) {
      dispatch(showSnackbar(Feedback.WARNING, formatMessage({id: 'protocolEditor.toast.closeHumidifierDoor'})));
      return false;
    }

    const isWaterLevelOk = await dispatch(checkAndPumpWater());
    if (!isWaterLevelOk) return false;

    return true;
  };

  return checkHumidityWarnings;
}

export default useHumidityWarnings;
